import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import components (lazy-loaded for performance)
const MaintenanceRequestsList = React.lazy(() => import("./MaintenanceRequestsList"));
const NewMaintenanceRequest = React.lazy(() => import("./NewMaintenanceRequest"));
const MaintenanceRequestDetails = React.lazy(() => import("./MaintenanceRequestDetails"));

const maintenanceRequestsModuleConfig: ModuleConfig = {
    // MODULE IDENTITY
    id: "maintenance-requests",
    name: "Maintenance Requests",
    description: "Log and track maintenance issues, repairs, and facility upkeep",
    version: "1.0.0",
    enabled: true,
    category: "operations",
    order: 5,
    icon: "🔧",
    color: "#E67E22",

    // ROUTES
    routes: [
        {
            path: "/maintenance-requests",
            component: MaintenanceRequestsList,
            permissions: ["USER"]
        },
        {
            path: "/maintenance-requests/new",
            component: NewMaintenanceRequest,
            permissions: ["USER"]
        },
        {
            path: "/maintenance-requests/:id",
            component: MaintenanceRequestDetails,
            permissions: ["USER"]
        }
    ],

    // NAVIGATION
    navigation: [
        {
            label: "All Requests",
            path: "/maintenance-requests",
            icon: "📋",
            permissions: ["USER"]
        },
        {
            label: "Log New Issue",
            path: "/maintenance-requests/new",
            icon: "➕",
            permissions: ["USER"]
        }
    ],

    // PERMISSIONS
    permissions: {
        view: ["USER"],
        create: ["USER"],
        edit: ["USER"],
        delete: ["ADMIN"]
    },

    // QUICK ACTIONS
    quickActions: [
        {
            label: "Log New Issue",
            path: "/maintenance-requests/new",
            icon: "📸",
            description: "Report a maintenance issue with photos"
        },
        {
            label: "View All Requests",
            path: "/maintenance-requests",
            icon: "📋",
            description: "View and manage all maintenance requests"
        }
    ],

    // CHANGELOG
    changelog: [
        {
            version: "1.0.0",
            releaseDate: "2025-12-18",
            title: "Initial Release - Maintenance Requests",
            features: [
                "Log maintenance requests with photos/videos",
                "Mobile-friendly camera capture",
                "Location integration from Location Register",
                "Status workflow (New → Assigned → In Progress → Completed)",
                "Repair person dashboard with filters",
                "Admin email notifications on new requests",
                "Completion photos and notes",
                "Analytics dashboard with avg completion time"
            ],
            notes: "First release of the Maintenance Request Register module. Staff can easily log issues from their phones with photos, and repair personnel can track and complete jobs."
        }
    ],

    // ROADMAP
    roadmap: [
        {
            title: "Assignment Notifications",
            description: "Email notifications when assigned to repair person",
            targetVersion: "1.1.0",
            priority: "high",
            status: "planned",
            features: [
                "Email to assigned repair person",
                "In-app notification",
                "Push notification support"
            ]
        },
        {
            title: "Recurring Maintenance",
            description: "Schedule recurring maintenance tasks",
            targetVersion: "1.2.0",
            priority: "medium",
            status: "planned",
            features: [
                "Weekly/monthly recurring requests",
                "Auto-create from templates",
                "Preventive maintenance scheduling"
            ]
        }
    ]
};

export default maintenanceRequestsModuleConfig;
